import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { ShieldCheck } from "lucide-react";

export default function KidLogin() {
  const [username, setUsername] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setSubmitting(true);
    try {
      await api.post("/kid-auth/login", { username: username.toLowerCase().trim(), pin });
      navigate("/kid");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F1EBD8]">
      <div className="w-full max-w-md card-soft p-8 md:p-10 fade-in-up">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#5C7A4E] text-white mb-4">
          <ShieldCheck size={22} />
        </div>
        <h2 className="font-heading text-3xl font-semibold text-[#2A2418]">Kid sign in</h2>
        <p className="text-[#7A6D52] mt-1 mb-8">Ask a parent for your username and PIN.</p>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="kid-login-form">
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#7A6D52]">Username</label>
            <input required data-testid="kid-username-input" value={username}
                   onChange={(e) => setUsername(e.target.value)}
                   className="mt-1 w-full rounded-xl border border-[#D8CCB0] bg-white px-4 py-3 outline-none focus:border-[#5C7A4E]" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.18em] text-[#7A6D52]">4-digit PIN</label>
            <input required data-testid="kid-pin-input" value={pin}
                   inputMode="numeric" pattern="[0-9]{4}" maxLength={4}
                   onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
                   className="mt-1 w-full rounded-xl border border-[#D8CCB0] bg-white px-4 py-3 outline-none focus:border-[#5C7A4E] font-mono tracking-widest" />
          </div>
          {error && <div className="text-sm text-[#B85C4A] bg-[#B85C4A]/10 rounded-xl px-3 py-2" data-testid="kid-login-error">{error}</div>}
          <button data-testid="kid-login-btn" disabled={submitting} className="w-full rounded-xl bg-[#5C7A4E] text-white px-6 py-3 font-medium hover:bg-[#4A6338] disabled:opacity-60">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#7A6D52] text-center">
          Parent? <Link to="/login" className="text-[#5C7A4E] hover:underline font-medium">Sign in here</Link>
        </p>
      </div>
    </div>
  );
}
